import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { StackModule } from '../stack/stack.module';

import { CardFooterComponent } from './card-footer.component';

@NgModule({
  declarations: [CardFooterComponent],
  imports: [CommonModule, StackModule],
  exports: [CardFooterComponent],
})
export class CardFooterModule {}
